import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useCart } from "@/lib/cart";
import { toast } from "sonner";
import { ShoppingBagOpen, BookOpen } from "@phosphor-icons/react";

export default function Comics() {
  const [comics, setComics] = useState([]);
  const { add } = useCart();

  useEffect(() => {
    api.get("/comics").then((r) => setComics(r.data));
  }, []);

  const addToCart = (c) => {
    add({ item_id: c.id, name: `${c.title} ${c.issue}`, price: c.price, image: c.cover_image, type: "comic" });
    toast.success(`Added ${c.issue} to cart`);
  };

  return (
    <div className="max-w-7xl mx-auto px-6 py-16" data-testid="comics-page">
      <div className="section-eyebrow">Read The Universe</div>
      <h1 className="font-display text-5xl lg:text-7xl uppercase mt-3">Comics</h1>
      <p className="text-dim mt-3 max-w-xl">Every issue of the SCU. Pre-order, subscribe, and ride the line with The Savage King.</p>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="comics-grid">
        {comics.map((c) => {
          const hasPreview = (c.pages || []).length > 0;
          return (
            <article key={c.id} className="scu-card" data-testid={`comic-card-${c.id}`}>
              <div className="aspect-[3/4] overflow-hidden bg-black relative">
                <img src={c.cover_image} alt={c.title} className="w-full h-full object-cover" />
                {c.featured && (
                  <div className="absolute top-4 left-4 bg-[#FF3B30] text-black px-3 py-1 font-display text-xs tracking-widest">FLAGSHIP</div>
                )}
                {hasPreview && (
                  <Link
                    to={`/comics/${c.id}/read`}
                    className="absolute bottom-4 right-4 bg-black/80 border border-white/20 hover:border-[#FF3B30] hover:text-[#FF3B30] text-white font-display text-xs uppercase tracking-widest px-3 py-2 inline-flex items-center gap-2 transition-colors"
                    data-testid={`comic-read-${c.id}`}
                  >
                    <BookOpen size={14} weight="bold" /> Read Preview
                  </Link>
                )}
              </div>
              <div className="p-6">
                <div className="font-display text-2xl uppercase">{c.title}</div>
                <div className="font-display text-[#FF3B30] tracking-widest mt-1">{c.issue}</div>
                <p className="text-dim mt-3 text-sm leading-relaxed">{c.synopsis}</p>
                <div className="mt-5 flex items-center justify-between">
                  <span className="font-display text-2xl">${c.price?.toFixed(2)}</span>
                  <button onClick={() => addToCart(c)} className="btn-red inline-flex items-center gap-2" data-testid={`comic-add-${c.id}`}>
                    <ShoppingBagOpen size={16} weight="bold" /> Add
                  </button>
                </div>
                <div className="mt-3 text-xs text-dim uppercase tracking-widest">Release: {c.release_date}</div>
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
}
